var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 321.502,
    height: 74.405,
    viewBox: "0 0 321.502 74.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1",
    x1: 0.471,
    y1: 0.799,
    x2: 1.011,
    y2: 0.016,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-21.642 -18.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M51.478,52.592l35.05-23.64a1.821,1.821,0,0,1,2.843,1.531L88.953,72.15h-.109c-5.869.31-12.8-1.258-19.521-4.374C60.865,63.838,54.322,58.006,51.478,52.592ZM87.385,76.16a47.864,47.864,0,0,1-19.721-4.794c-9.223-4.3-16.149-10.426-19.484-16.55L30.354,66.846a1.834,1.834,0,0,0,.784,3.336l29.928,4.065A7.329,7.329,0,0,1,65.6,76.688L85.49,99.417A1.832,1.832,0,0,0,88.7,98.232l.219-22.109C88.406,76.141,87.9,76.16,87.385,76.16Z",
    transform: "translate(-7.906 -6.715)",
    fill: "url(#linear-gradient-1)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "YourLogo",
    transform: "translate(108.145 78.922)",
    fontSize: 56,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "YourLogo")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.68c6380368aaf7e6d85ea755f041c28c.svg";
export { ForwardRef as ReactComponent };